import React from 'react';
import { Card } from 'reactstrap';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { gql } from 'apollo-boost';
import ProductLotsCard from './productLotsCard';
import UserFullname from '~/components/userFullname/userFullname';

export const getProductPendingLotsQuery = gql`
  query product($id: Int!) {
    product(id: $id) {
      id
      pendingLots {
        id
        volume
        reference
        startDate
        createdByUser {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

const PendingLots = ({ lots }) => (
  <Card>
    {lots.map(lot => {
      const { id, volume, reference, startDate, createdByUser } = lot;

      return (
        <div key={id} className="bb-divider pa3 flex">
          <div className="flex-grow-1">
            <p className="f5">
              <Link to={`/lots/${id}`}>{reference}</Link>
            </p>
            <p>
              Due to start on {moment(startDate).format('dddd Do MMMM')}. Scheduled by{' '}
              <UserFullname user={createdByUser} />
            </p>
          </div>
          <div>
            <p>Volume: {volume}L</p>
          </div>
        </div>
      );
    })}
  </Card>
);

const ProductPendingLotsCard = props => (
  <ProductLotsCard
    {...props}
    query={getProductPendingLotsQuery}
    queryKey="pendingLots"
    render={PendingLots}
    title="Pending lots
"
  />
);

export default ProductPendingLotsCard;



// WEBPACK FOOTER //
// ./src/containers/productLotsCard/pending.jsx